'use strict';

wbApp.factory('gridSortSvc', ['languageService', 'tenantSettingSvc',
    function (languageService, tenantSettingSvc) {

        function date(value) {
            if (!value) {
                return new Date(0);
            }

            return new Date(value);
        }

        var csTranslateTable = {
            'á': 'a{',
            'č': 'c{',
            'ď': 'd{',
            'é': 'e{',
            'ě': 'e|',
            'í': 'i{',
            'ň': 'n{',
            'ó': 'o{',
            'ř': 'r{',
            'š': 's{',
            'ť': 't{',
            'ú': 'u{',
            'ů': 'u|',
            'ý': 'y{',
            'ž': 'z{',
            'ch': 'h{'
        };

        function localeCS(value) {
            var res = '';
            var i = 0
            while (i < value.length) {
                var ch = value[i];
                if (ch === 'c' && ((i + 1) < value.length) && value[i + 1] === 'h') {
                    i++;
                    res = res + csTranslateTable['ch'];
                } else {
                    var tr = csTranslateTable[ch];
                    if (tr) {
                        res = res + tr;
                    } else {
                        res = res + ch;
                    }
                }
                i++;
            }
            return res;
        }

        var localeFn = {
            cs: localeCS,
            en: function (value) { return value; },
            de: function (value) { return value; },
            sk: function (value) { return value; }
        }

        function locale(value, language) {
            if (!language) {
                language = languageService.currentLanguage().key;
            }

            if (!value) {
                return value;
            }

            return localeFn[language](angular.lowercase(value));
        }

        function humanName(value) {
            if (!value) {
                return value;
            }

            var res = '';
            var spl = value.split(' ');
            for (var i = spl.length - 1; i >= 0; i--) {
                res += spl[i];
            }

            return locale(res);
        }

        function sortHumanFullName(data, nameProperty, surnameProperty, middleNameProperty) {
            if (tenantSettingSvc.settings.sortNamesBySurname) {
                return locale(data[surnameProperty]) + ' ' + locale(data[middleNameProperty]) + ' ' + locale(data[nameProperty]);
            } else {
                return locale(data[nameProperty]) + ' ' + locale(data[middleNameProperty]) + ' ' + locale(data[surnameProperty]);
            }
        }

        function sortHumanFullName2(data, fullNameProperty) {
            if (tenantSettingSvc.settings.sortNamesBySurname) {
                var arr = _.words(data[fullNameProperty]);

                if (arr.length <= 3) {
                    return locale(_.join(_.reverse(arr), ' '));
                }

                let rest = _.drop(arr, 3);
                let start = _.slice(arr, 0, 3);

                return locale(_.join(_.concat(_.reverse(start), rest), ' '));
            } else {
                return locale(data[fullNameProperty]);
            }
        }
        
        function filterExpressionWithoutAccents(filterValue, selectedFilterOperation, target, propertyName) {
            let getter = function (data) {
                return (data[propertyName] === undefined || data[propertyName] === null || data[propertyName].normalize === undefined)
                    ? data[propertyName]
                    : data[propertyName].normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            };

            filterValue = (filterValue === undefined || filterValue === null || filterValue.normalize === undefined)
                ? filterValue
                : filterValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            return [getter, selectedFilterOperation || "contains", filterValue];
        }

        function localeSort(data, propertyName) {
            return locale(data[propertyName]);
        }

        return {
            humanName: humanName,
            date: date,
            locale: locale,
            sortHumanFullName: sortHumanFullName,
            sortHumanFullName2: sortHumanFullName2,
            localeSort: localeSort,
            filterExpressionWithoutAccents: filterExpressionWithoutAccents
        }

    }]);